import { useEffect, useState } from 'react';
import { Button, Typography } from '@mui/material';
import { SupportAgent } from '@mui/icons-material';

const SCRIPT_URL = 'https://ticket.saotech.com.br/assets/chat/chat-no-jquery.min.js';
let carregamento;

function carregarChat() {
  if (window.ZammadChat) return Promise.resolve();
  if (!carregamento) {
    carregamento = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = SCRIPT_URL;
      script.async = true;
      script.onload = () => {
        if (window.ZammadChat) resolve();
        else {
          script.remove();
          carregamento = null;
          reject(new Error('Chat indisponível'));
        }
      };
      script.onerror = () => {
        script.remove();
        carregamento = null;
        reject(new Error('Chat indisponível'));
      };
      document.head.appendChild(script);
    });
  }
  return carregamento;
}

export default function SupportChat() {
  const [estado, setEstado] = useState('carregando');

  useEffect(() => {
    let ativo = true;
    let chat;
    const botao = document.querySelector('.open-zammad-chat');

    carregarChat().then(() => {
      if (!ativo) return;
      chat = new window.ZammadChat({
        title: 'Falar com o suporte',
        background: '#0b99cc',
        fontSize: '12px',
        chatId: 1,
        show: false,
        onReady: () => { if (ativo) setEstado('pronto'); },
        onError: () => { if (ativo) setEstado('erro'); }
      });
    }).catch(() => { if (ativo) setEstado('erro'); });

    return () => {
      ativo = false;
      if (chat) {
        botao?.removeEventListener('click', chat.open);
        chat.destroy({ remove: true });
      }
    };
  }, []);

  return (
    <>
      <Button
        type="button"
        className="open-zammad-chat"
        variant="contained"
        fullWidth
        startIcon={<SupportAgent />}
        disabled={estado !== 'pronto'}
        sx={{ backgroundColor: '#0b99cc', '&:hover': { backgroundColor: '#087ca6' } }}
      >
        Falar com o suporte
      </Button>
      {estado === 'erro' && (
        <Typography variant="caption" role="status" color="text.secondary" textAlign="center">
          Chat de suporte indisponível no momento.
        </Typography>
      )}
    </>
  );
}
